import React from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import { Grid } from '@mui/material';

import { useFormState } from 'shared/hooks';
import Button from 'shared/components/buttons/Button/Button';
import InputField from 'shared/components/forms/InputField/InputField';
import { requiredString } from 'utils/constants';

const schema = yup.object().shape({
  title: yup.string().required(requiredString),
  description: yup.string().required(requiredString),
  link: yup.string().url('Invalid url').required(requiredString),
});

const ClinicalDecisionSupportForm = ({ defaultValues, onSubmit, onCancel }) => {
  const { getFieldError, register, handleSubmit } = useFormState(
    schema,
    { stateSlice: 'admin', showAsSnackbar: true },
    defaultValues,
  );

  const handleFormSubmit = (moreValues) => {
    onSubmit({
      ...moreValues,
    });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InputField
            {...register('title', {
              required: true,
            })}
            required
            label="Title"
            placeholder="Title"
            error={getFieldError('title')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField
            {...register('link', {
              required: true,
            })}
            required
            label="Hyperlink"
            placeholder="Hyperlink"
            error={getFieldError('link')}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <InputField
            {...register('description', {
              required: true,
            })}
            required
            multiline
            rows={6}
            label="Description"
            placeholder="Description"
            error={getFieldError('description')}
          />
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end">
          <Button color="secondary" variant="contained" type="submit">
            Save
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            sx={{ marginLeft: '1rem' }}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

ClinicalDecisionSupportForm.propTypes = {
  defaultValues: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClinicalDecisionSupportForm;
